import BestSellingItem from "../components/BestSellingItem";
import CustomerRatting from "../components/CustomerRatting";
import FoodPreparationTime from "../components/FoodPreparationTime";
import Sales from "../components/Sales";
import TopCard from "../components/TopCard";
import { useRestaurant } from "../context/RestaurantContext";

const Home = () => {
  const { isRestaurantOpen } = useRestaurant();

  return (
    <div className="max-w-[1400px] mx-auto pb-20 md:pb-0 bg-white dark:bg-gray-900 min-h-screen transition-colors">
      <TopCard />
      {isRestaurantOpen && (
        <div className="">
          <div className="hidden md:block">
            <div className="flex flex-col md:flex-row justify-between items-start gap-4 md:gap-8 px-4 md:px-8 py-4 bg-[#F9F9F9] dark:bg-gray-800 transition-colors">
              <div className="w-full md:w-[70%]">
                <BestSellingItem />
                <div className="mt-4">
                  <FoodPreparationTime />
                </div>
              </div>
              <div className="w-full md:w-[30%]">
                <Sales />
                <CustomerRatting />
              </div>
            </div>
          </div>

          <div className="block md:hidden p-2">
            <Sales />
            <FoodPreparationTime />
            <BestSellingItem />
            <CustomerRatting />
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
